/**
 * MorningBriefCard — Sprint 7 · Project Symphony
 *
 * Compact card. Operations, not analytics. Renders at the top of the
 * Command Center. Silent when there is nothing to say.
 */
import { useQuery } from "@tanstack/react-query";
import { Sunrise } from "lucide-react";

import { Card } from "@/shared/ui/card";
import { getMorningBrief } from "../api";

export function MorningBriefCard(): JSX.Element | null {
  const q = useQuery({
    queryKey: ["autopilot-brief-morning"],
    queryFn: getMorningBrief,
    refetchInterval: 300_000, // every 5 minutes
  });

  if (!q.data) return null;
  const brief = q.data;

  return (
    <Card className="p-5" data-testid="morning-brief-card">
      <div className="flex items-center gap-2 mb-3">
        <Sunrise className="h-4 w-4 text-amber-500" aria-hidden />
        <span className="text-xs uppercase tracking-widest text-muted-foreground">
          Morning Brief
        </span>
      </div>
      <ul className="space-y-2">
        {brief.lines.map((line, i) => (
          <li key={i} className="text-sm">
            {line}
          </li>
        ))}
      </ul>
    </Card>
  );
}
